module.exports = __webpack_public_path__ + "b439e02f10feb8e3f8e7b5efe67f6e22.svg";